import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';

import SignupButton from '../components/buttons/SignupButton';

const Pricing = () => (
  <div className="PricingPage">
    <Helmet
      title="Pricing"
      meta={[
        { name: 'robots', content: 'noimageindex,noarchive,nosnippet' },
      ]}
    />

    <div className="PricingPage__header">
      <div className="container">
        <h1>The new way to manage your radon testing business</h1>
      </div>
    </div>

    <div className="PricingPage__body">
      <div className="container">
        <div className="card">
          <h5 className="card-header">Standard Plan</h5>
          <div className="card-body">
            <h5 className="card-title">
              $39
              <small>.95</small>
              /mo
            </h5>
            <p className="card-text">For businesses of all sizes.</p>

            <SignupButton className="btn btn-light btn-lg" />

            <Link
              to="/demo-request"
              className="btn btn-outline-light btn-lg"
            >
              Book a Demo
            </Link>
            <div>
              <ul className="plan-details">
                <li><FontAwesomeIcon icon={['fal', 'check']} /><b>Unlimited</b> employees</li>
                <li><FontAwesomeIcon icon={['fal', 'check']} /><b>Unlimited</b> tests</li>
                <li><FontAwesomeIcon icon={['fal', 'check']} /><b>Unlimited</b> reports</li>
                <li><FontAwesomeIcon icon={['fal', 'check']} /><b>Premium</b> support</li>
                <li><FontAwesomeIcon icon={['fal', 'check']} /><b>Detailed</b> analytics</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Pricing;



// WEBPACK FOOTER //
// ./src/pages/pricing.js